/** A stored JSON value back as state: `fallback` when nothing is stored or `parse` rejects it. */
export function resolveStoredJson<T>(
  stored: unknown,
  fallback: T,
  parse: (stored: unknown) => T | null
): T {
  return stored === null ? fallback : (parse(stored) ?? fallback);
}

/** Guards a stored list of ids, which a person or an older build could have left malformed. */
export function parseStoredStringList(value: unknown): string[] | null {
  return Array.isArray(value) && value.every(item => typeof item === 'string') ? value : null;
}

/** `list` with `item` removed if present, else appended. */
export function toggleListItem<T>(list: readonly T[], item: T): T[] {
  return list.includes(item) ? list.filter(entry => entry !== item) : [...list, item];
}
